var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height:this.height+'px', width: '100%'}),attrs:{"id":"map"}})
}
var staticRenderFns = []

export { render, staticRenderFns }